import React, { useState } from 'react'

// resources
import PlusIcon from 'assets/icons/plus-icon-8x8.svg?component'
import MinusIcon from 'assets/icons/minus-icon-8x8.svg?component'

// styles
import styles from './index.module.scss'

const NFTDescriptionSection = props => {
  const { description } = props
  const [showDetails, setShowDetails] = useState(false)

  return (
    <div className="w-full">
      <div className="w-full flex justify-between items-start gap-[15px]" onClick={() => setShowDetails(!showDetails)}>
        <div className={`${showDetails ? '' : styles.limitLines} ${styles.details}`}>{description}</div>
        <div className="w-[16px] h-[16px] flex items-center justify-center">
          {showDetails ? <MinusIcon /> : <PlusIcon />}
        </div>
      </div>

      <div className={styles.descBorder} />
    </div>
  )
}

export default NFTDescriptionSection
